import axios from "axios";
import { useQuery } from "react-query";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { END_POINT } from "config/environment";

export const QUERY_KEY_FOR_JOBS = "report-reasons";

interface IGetDataProps {
  token?: string;
}

const getData = async (props: IGetDataProps) => {
  const url = `${END_POINT.BASE_URL}/v1/get-reasons`;

  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };

  const res = await axios.get(url, config);
  const data = res.data;
//   console.log(res);
  
  
  return data;
};

export const useGetReportReasons = () => {
  const { token } = useGetUserInfo();
  const queryData = useQuery(
    [QUERY_KEY_FOR_JOBS],
    () =>
      getData({
        token,
      }),
    {
      onError: (err: any) => {},
      onSuccess: (data) => {},
    }
  );

  return queryData;
};
